import React from "react";
import { useEffect, useState } from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router";
import birthdaybg from "./images/birthdaybg.png";
import birthdaycarousel1 from "./images/birthdaycarousel1.png";
import birthdaycarousel2 from "./images/birthdaycarousel2.jpg";
import birthdaycarousel3 from "./images/birthdaycarousel3.jpg";
import corporatebg from "./images/corporatebg.png";
import corporatecarousel1 from "./images/corporatecarousel1.jpg";
import corporatecarousel2 from "./images/corporatecarousel2.jpg";
import corporatecarousel3 from "./images/corporatecarousel3.jpg";
import schooltripbg from "./images/schooltripbg.png";
import schooltripcarousel1 from "./images/schooltripcarousel1.jpg";
import schooltripcarousel2 from "./images/schooltripcarousel2.jpg";
import schooltripcarousel3 from "./images/schooltripcarousel3.jpg";
import otherevenbg from "./images/othereventbg.png";
import othereventcarousel1 from "./images/othereventcarousel1.png";
import othereventcarousel2 from "./images/othereventcarousel2.png";
import othereventcarousel3 from "./images/othereventcarousel3.png";

import { scrollToBottom } from "../../utils";
import Carousel from "./Carousel";

import { heart, loaderGif, bookNow } from "../../assets";

import { scrollToTop } from "../../utils/index";

const Events = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Create image arrays for each event type
  const birthdayImages = [
    {
      id: 1,
      src: birthdaycarousel1,
      alt: "Birthday celebration 1",
    },
    {
      id: 2,
      src: birthdaycarousel2,
      alt: "Birthday celebration 2",
    },
    {
      id: 3,
      src: birthdaycarousel3,
      alt: "Birthday celebration 3",
    },
  ];

  const corporateImages = [
    {
      id: 1,
      src: corporatecarousel1,
      alt: "Corporate event 1",
    },
    {
      id: 2,
      src: corporatecarousel2,
      alt: "Corporate event 2",
    },
    {
      id: 3,
      src: corporatecarousel3,
      alt: "Corporate event 3",
    },
  ];

  const schoolTripImages = [
    {
      id: 1,
      src: schooltripcarousel1,
      alt: "School trip 1",
    },
    {
      id: 2,
      src: schooltripcarousel2,
      alt: "School trip 2",
    },
    {
      id: 3,
      src: schooltripcarousel3,
      alt: "School trip 3",
    },
  ];

  const otherEventImages = [
    {
      id: 1,
      src: othereventcarousel1,
      alt: "Other event 1",
    },
    {
      id: 2,
      src: othereventcarousel2,
      alt: "Other event 2",
    },
    {
      id: 3,
      src: othereventcarousel3,
      alt: "Other event 3",
    },
  ];

  return (
    <>
      {/* birthday party */}
      <Grid
        container
        sx={{
          width: "100vw",
          minHeight: "100vh",
          background: `url(${birthdaybg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(56, 148, 255, 0.85) 0%, rgba(17, 86, 165, 0.85) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Left Content Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "center", lg: "flex-start" },
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6, lg: 8 },
            py: { xs: 4, lg: 0 },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Box
            sx={{
              maxWidth: "600px",
              zIndex: 2,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", lg: "flex-start" },
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.5rem",
                  md: "4.5rem",
                  lg: "5.5rem",
                },
                fontWeight: "bold",
                lineHeight: 1.1,
                mb: 3,
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              BIRTHDAY
              <br />
              PARTIES
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",
                  sm: "1.1rem",
                  md: "1.25rem",
                  lg: "1.4rem",
                },
                lineHeight: 1.6,
                mb: 4,
                opacity: 0.95,
                maxWidth: { xs: "100%", lg: "500px" },
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              Celebrate birthdays with non-stop fun at
              <br />
              Funingo Adventure Arena!
              <br />
              Thrills, laughter, and unforgettable memories
              <br />
              await your little adventurers!
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", lg: "flex-start" },
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  navigate("/book");
                  scrollToTop();
                }}
                sx={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: { xs: "12px 32px", sm: "16px 40px" },
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "50px",
                  border: "3px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#45a049",
                    transform: "translateY(-3px) scale(1.02)",
                    boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                  },
                }}
              >
                BOOK NOW
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Right Carousel Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, lg: 0 },
          }}
        >
          <Carousel images={birthdayImages} />
        </Grid>
      </Grid>

      {/* corporate event */}
      <Grid
        container
        sx={{
          width: "100vw",
          minHeight: "100vh",
          background: `url(${corporatebg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(86, 151, 176, 0.9) 0%, rgba(2, 104, 147, 0.9) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Left Content Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "center", lg: "flex-start" },
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6, lg: 8 },
            py: { xs: 4, lg: 0 },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Box
            sx={{
              maxWidth: "600px",
              zIndex: 2,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", lg: "flex-start" },
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.5rem",
                  md: "4.5rem",
                  lg: "5.5rem",
                },
                fontWeight: "bold",
                lineHeight: 1.1,
                mb: 3,
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              CORPORATE
              <br />
              EVENTS
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",
                  sm: "1.1rem",
                  md: "1.25rem",
                  lg: "1.4rem",
                },
                lineHeight: 1.6,
                mb: 4,
                opacity: 0.95,
                maxWidth: { xs: "100%", lg: "500px" },
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              Host your next corporate event at
              <br />
              Funingo Adventure Arena!
              <br />
              Team bonding meets thrilling adventure for
              <br />
              an experience they'll never forget!
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", lg: "flex-start" },
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  navigate("/book");
                  scrollToTop();
                }}
                sx={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: { xs: "12px 32px", sm: "16px 40px" },
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "50px",
                  border: "3px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#45a049",
                    transform: "translateY(-3px) scale(1.02)",
                    boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                  },
                }}
              >
                BOOK NOW
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Right Carousel Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, lg: 0 },
          }}
        >
          <Carousel images={corporateImages} />
        </Grid>
      </Grid>

      {/* school event  */}
      <Grid
        container
        sx={{
          width: "100vw",
          minHeight: "100vh",
          background: `url(${schooltripbg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(129, 128, 92, 0.9) 0%, rgba(207, 200, 29, 0.9) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Left Content Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "center", lg: "flex-start" },
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6, lg: 8 },
            py: { xs: 4, lg: 0 },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Box
            sx={{
              maxWidth: "600px",
              zIndex: 2,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", lg: "flex-start" },
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.5rem",
                  md: "4.5rem",
                  lg: "5.5rem",
                },
                fontWeight: "bold",
                lineHeight: 1.1,
                mb: 3,
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              SCHOOL
              <br />
              TRIP
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",
                  sm: "1.1rem",
                  md: "1.25rem",
                  lg: "1.4rem",
                },
                lineHeight: 1.6,
                mb: 4,
                opacity: 0.95,
                maxWidth: { xs: "100%", lg: "500px" },
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              Plan an action-packed school trip at
              <br />
              Funingo Adventure Arena!
              <br />
              Fun, learning, and adventure—everything
              <br />
              students love in one place!
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", lg: "flex-start" },
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  navigate("/book");
                  scrollToTop();
                }}
                sx={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: { xs: "12px 32px", sm: "16px 40px" },
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "50px",
                  border: "3px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#45a049",
                    transform: "translateY(-3px) scale(1.02)",
                    boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                  },
                }}
              >
                BOOK NOW
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Right Carousel Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, lg: 0 },
          }}
        >
          <Carousel images={schoolTripImages} />
        </Grid>
      </Grid>

      {/* other events */}
      <Grid
        container
        sx={{
          width: "100vw",
          minHeight: "100vh",
          background: `url(${otherevenbg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(180deg, rgba(88, 182, 101, 0.9) 0%, rgba(1, 130, 19, 0.9) 100%)",
            zIndex: 1,
          },
        }}
      >
        {/* Left Content Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: { xs: "center", lg: "flex-start" },
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6, lg: 8 },
            py: { xs: 4, lg: 0 },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <Box
            sx={{
              maxWidth: "600px",
              zIndex: 2,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", lg: "flex-start" },
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.5rem",
                  md: "4.5rem",
                  lg: "5.5rem",
                },
                fontWeight: "bold",
                lineHeight: 1.1,
                mb: 3,
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              OTHER
              <br />
              EVENTS
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",
                  sm: "1.1rem",
                  md: "1.25rem",
                  lg: "1.4rem",
                },
                lineHeight: 1.6,
                mb: 4,
                opacity: 0.95,
                maxWidth: { xs: "100%", lg: "500px" },
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              Plan an action-packed school trip at
              <br />
              Funingo Adventure Arena!
              <br />
              Fun, learning, and adventure—everything
              <br />
              students love in one place!
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", lg: "flex-start" },
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  navigate("/book");
                  scrollToTop();
                }}
                sx={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  padding: { xs: "12px 32px", sm: "16px 40px" },
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderRadius: "50px",
                  border: "3px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#45a049",
                    transform: "translateY(-3px) scale(1.02)",
                    boxShadow: "0 8px 25px rgba(76, 175, 80, 0.6)",
                  },
                }}
              >
                BOOK NOW
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Right Carousel Section */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: { xs: "50vh", lg: "100vh" },
            zIndex: 2,
            position: "relative",
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, lg: 0 },
          }}
        >
          <Carousel images={otherEventImages}/>
        </Grid>
      </Grid>
    </>
  );
};

export default Events;
